import React from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import * as MaterialDesign from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { theme } from '@style/theme';
import { useLocation } from '@tanstack/react-router';

const MenuItems = ({
  item,
  open,
  handleMenuClick,
  handleMenuClose,
  navigate,
  hasPermission,
  menuAnchorEl,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const isActive = location.pathname === item.url;

  return (
    <div
      key={item.id}
      onMouseLeave={handleMenuClose}
      className={`menu-item ${isActive ? 'active' : ''}`}
    >
      <button
        onClick={() => item.url && navigate({ to: item.url })}
        onMouseEnter={(e) => handleMenuClick(e, item.id)}
        className='menu-button'
      >
        <span className='menu-label'>{t(item.key)}</span>
        {item.subMenu && (
          <img src='/assets/svg/arrow-down-icon.svg' alt='' className='menu-arrow' />
        )}
      </button>
      {item.subMenu && (
        <Menu
          open={open === item.id}
          anchorEl={menuAnchorEl}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          disablePortal
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          sx={{
            pointerEvents: 'none',
            '& .MuiPaper-root': {
              pointerEvents: 'auto',
              borderRadius: '8px',
            },
          }}
          onMouseLeave={handleMenuClose}
        >
          {item.subMenu
            .filter((subItem) => hasPermission(subItem.roles))
            .map((subItem) => (
              <MenuItem
                key={subItem.title}
                onClick={() => {
                  handleMenuClose();
                  navigate({ to: subItem?.url });
                }}
                sx={{
                  minHeight: '48px',
                  justifyContent: 'flex-start',
                  '.MuiListItemText-root': {
                    color:
                      location.pathname === subItem.url
                        ? theme.colors.primary
                        : theme.colors.textDark,
                  },
                  '.nav-icon': {
                    color:
                      location.pathname === subItem.url
                        ? theme.colors.primary
                        : theme.colors.main,
                  },
                  '&:hover': {
                    '.MuiListItemText-root': {
                      color: theme.colors.primary,
                    },
                    '.nav-icon': {
                      color: theme.colors.primary,
                    },
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: theme.colors.main,
                  }}
                  className='nav-icon'
                >
                  {React.createElement(MaterialDesign[subItem.icon])}
                </ListItemIcon>
                <ListItemText primary={t(subItem.title)} />
              </MenuItem>
            ))}
        </Menu>
      )}
    </div>
  );
};

export default MenuItems;
